<li><div class="q"><slot name="q"></slot></div><transition><div class="a"><slot name="a"></slot></div></transition></li>